import { render, staticRenderFns } from "./listOrcamento.vue?vue&type=template&id=13c0faaa"
import script from "./listOrcamento.ts?vue&type=script&lang=js&external"
export * from "./listOrcamento.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c0faaa')) {
      api.createRecord('13c0faaa', component.options)
    } else {
      api.reload('13c0faaa', component.options)
    }
    module.hot.accept("./listOrcamento.vue?vue&type=template&id=13c0faaa", function () {
      api.rerender('13c0faaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/listOrcamento.vue"
export default component.exports